"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventReminderTemplateEn = void 0;
exports.eventReminderTemplateEn = {
    root: {
        type: "EmailLayout",
        data: {
            backdropColor: "#F9F9F9",
            canvasColor: "#F9F9F9",
            borderColor: null,
            textColor: "#000000",
            fontFamily: "MODERN_SANS",
            childrenIds: [
                "block-1788511558246-1",
                "block-1788511558246-2",
                "block-1788511558247-3",
                "block-1788511558247-4",
                "block-1788511558247-5",
            ],
        },
    },
    "block-1788511558246-1": {
        type: "Image",
        data: {
            style: {
                backgroundColor: "#ffffff",
                padding: {
                    top: 16,
                    right: 24,
                    bottom: 16,
                    left: 24,
                },
                textAlign: "center",
            },
            props: {
                url: "https://www.zeffy.com/images/emails/reminder-notification-bell.jpg",
                width: 162,
                alt: "",
                linkHref: null,
                contentAlignment: "middle",
            },
        },
    },
    "block-1788511558246-2": {
        type: "Html",
        data: {
            style: {
                color: "#0f0e5b",
                backgroundColor: "#ffffff",
                fontSize: 22,
                fontFamily: "MODERN_SANS",
                padding: {
                    top: 16,
                    right: 24,
                    bottom: 16,
                    left: 24,
                },
                textAlign: "center",
            },
            props: {
                contents: '<div id="email-content-wrapper"><style>#email-content-wrapper p, #email-content-wrapper h1, #email-content-wrapper h2, #email-content-wrapper h3, #email-content-wrapper h4 { margin: 0; word-wrap: break-word; overflow-wrap: break-word; }\n#email-content-wrapper p, #email-content-wrapper li, #email-content-wrapper ul, #email-content-wrapper ol { line-height: 1.5; }\n#email-content-wrapper li:has(> ul), #email-content-wrapper li:has(> ol) { list-style: none; }\n#email-content-wrapper h1 { font-weight: 500; font-size: 40px; line-height: 1.2; letter-spacing: -0.25px; }\n#email-content-wrapper h2 { font-weight: 500; font-size: 28px; line-height: 1.25; letter-spacing: 0; }\n#email-content-wrapper h3 { font-weight: 500; font-size: 22px; line-height: 1.3; letter-spacing: 0.25px; }\n#email-content-wrapper h4 { font-weight: 500; font-size: 18px; line-height: 1.35; letter-spacing: 0; }\n@media only screen and (max-width: 480px) {\n  #email-content-wrapper h1 { font-size: 34px !important; line-height: 1.2 !important; }\n  #email-content-wrapper h2 { font-size: 24px !important; line-height: 1.25 !important; }\n  #email-content-wrapper h3 { font-size: 20px !important; line-height: 1.3 !important; }\n  #email-content-wrapper h4 { font-size: 16px !important; line-height: 1.35 !important; }\n}</style><h3 style="text-align: center"><strong>Reminder!<br />{{event_name}} is coming up</strong></h3></div>',
            },
        },
    },
    "block-1788511558247-3": {
        type: "Html",
        data: {
            style: {
                color: "#0f0e5b",
                backgroundColor: "#ffffff",
                fontSize: 14,
                fontFamily: "MODERN_SANS",
                textAlign: "left",
                padding: {
                    top: 16,
                    right: 24,
                    bottom: 16,
                    left: 24,
                },
            },
            props: {
                contents: '<div id="email-content-wrapper"><style>#email-content-wrapper p, #email-content-wrapper h1, #email-content-wrapper h2, #email-content-wrapper h3, #email-content-wrapper h4 { margin: 0; word-wrap: break-word; overflow-wrap: break-word; }\n#email-content-wrapper p, #email-content-wrapper li, #email-content-wrapper ul, #email-content-wrapper ol { line-height: 1.5; }\n#email-content-wrapper li:has(> ul), #email-content-wrapper li:has(> ol) { list-style: none; }\n#email-content-wrapper h1 { font-weight: 500; font-size: 40px; line-height: 1.2; letter-spacing: -0.25px; }\n#email-content-wrapper h2 { font-weight: 500; font-size: 28px; line-height: 1.25; letter-spacing: 0; }\n#email-content-wrapper h3 { font-weight: 500; font-size: 22px; line-height: 1.3; letter-spacing: 0.25px; }\n#email-content-wrapper h4 { font-weight: 500; font-size: 18px; line-height: 1.35; letter-spacing: 0; }\n@media only screen and (max-width: 480px) {\n  #email-content-wrapper h1 { font-size: 34px !important; line-height: 1.2 !important; }\n  #email-content-wrapper h2 { font-size: 24px !important; line-height: 1.25 !important; }\n  #email-content-wrapper h3 { font-size: 20px !important; line-height: 1.3 !important; }\n  #email-content-wrapper h4 { font-size: 16px !important; line-height: 1.35 !important; }\n}</style><p>Thank you for registering to attend {{event_name}}.</p>\n<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;">Here are some details about the event:<br /><strong><br /></strong></p>\n<p style="line-height: 140%;"><strong>📍 {{event_location}}</strong></p>\n<p style="line-height: 140%;"><strong>📅 <span class="fr-deletable styled-tag-chip" contenteditable="false" data-custom-variable="{{date-variable-6af4c377-e9e4-4a3b-ada7-ccf686a84332}}" style="background-color:rgb(248, 248, 255);border:1px solid rgb(191, 191, 255);border-radius:4px;color:rgb(42, 42, 196);padding:1px 8px;font-size:11px;line-height:16px;display:inline-block;margin:0px;overflow-wrap:anywhere;user-select:none;box-sizing:inherit" original-style="">Event start date</span></strong></p>\n<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;">We look forward to seeing you there.</p>\n<p style="line-height: 140%;"> </p>\n<p style="line-height: 140%;">Sincerely,</p>\n<p style="line-height: 140%;"><br />{{organization_name}}</p></div>',
            },
        },
    },
    "block-1788511558247-4": {
        type: "Image",
        data: {
            style: {
                backgroundColor: "#e1e1e1",
                padding: {
                    top: 16,
                    right: 24,
                    bottom: 16,
                    left: 24,
                },
                textAlign: "center",
            },
            props: {
                url: "{{organization_logo_url}}",
                width: 60,
                alt: "organization logo",
                linkHref: null,
                contentAlignment: "middle",
            },
        },
    },
    "block-1788511558247-5": {
        type: "Html",
        data: {
            style: {
                color: "#9c9c9c",
                backgroundColor: "#e1e1e1",
                fontSize: 14,
                fontFamily: "MODERN_SANS",
                textAlign: "center",
                padding: {
                    top: 16,
                    right: 24,
                    bottom: 16,
                    left: 24,
                },
            },
            props: {
                contents: '<div id="email-content-wrapper"><style>#email-content-wrapper p, #email-content-wrapper h1, #email-content-wrapper h2, #email-content-wrapper h3, #email-content-wrapper h4 { margin: 0; word-wrap: break-word; overflow-wrap: break-word; }\n#email-content-wrapper p, #email-content-wrapper li, #email-content-wrapper ul, #email-content-wrapper ol { line-height: 1.5; }\n#email-content-wrapper li:has(> ul), #email-content-wrapper li:has(> ol) { list-style: none; }\n#email-content-wrapper h1 { font-weight: 500; font-size: 40px; line-height: 1.2; letter-spacing: -0.25px; }\n#email-content-wrapper h2 { font-weight: 500; font-size: 28px; line-height: 1.25; letter-spacing: 0; }\n#email-content-wrapper h3 { font-weight: 500; font-size: 22px; line-height: 1.3; letter-spacing: 0.25px; }\n#email-content-wrapper h4 { font-weight: 500; font-size: 18px; line-height: 1.35; letter-spacing: 0; }\n@media only screen and (max-width: 480px) {\n  #email-content-wrapper h1 { font-size: 34px !important; line-height: 1.2 !important; }\n  #email-content-wrapper h2 { font-size: 24px !important; line-height: 1.25 !important; }\n  #email-content-wrapper h3 { font-size: 20px !important; line-height: 1.3 !important; }\n  #email-content-wrapper h4 { font-size: 16px !important; line-height: 1.35 !important; }\n}</style><p><strong>{{organization_name}}</strong></p></div>',
            },
        },
    },
};
